module.exports = __webpack_public_path__ + "static/media/18_4.d18764c3.png";